import React from "react";
import Layout from "../../components/layout";

import employersBGElem from "../../images/bg-element-4.png";
import person from "../../images/person.png";

export default () => (
	<Layout>
		<div id="page-basic-content">
			<div class="section section-contact no-margin">
				<div class="container">
					<div class="row">
						<div class="intro col-12 text-center">
							<h1>Contact the Band</h1>
							<h2>Here with a helping Hand</h2>
						</div>
					</div>
				</div>

				<div class="top" style={{ padding: 0 }}>
					{/* <img class="person" src={person} /> */}
					<img className="bg-elem img img-fluid" src={employersBGElem} />
				</div>
				<div class="container">
					<div class="row">
						<div class="col-sm-6">
							<h4>Address: </h4>
							<a href="https://goo.gl/maps/aa7JUaapfEkTSVJc6" target="_blank">
								Band of Hands HQ <br />
								9320 Chesapeake Dr, Ste 101 <br />
								San Diego CA 92123
							</a>
							<h4 class="mt-2">Telephone: </h4>
							<a href="tel:8582843700">+1 (858) 284-3700</a>
						</div>

						<div class="col-sm-6">
							<h4>Contact:</h4>
							<div class="row">
								<div class="col-sm-6">
									<input class="form-control" type="text" placeholder="Your Name" required></input>
								</div>
								<div class="col-sm-6">
									<input class="form-control" type="text" placeholder="Your Email Address" required></input>
								</div>
								<div class="col-12 mt-2 mb-2">
									<textarea class="form-control" rows="7" type="textarea" placeholder="Your Message" required></textarea>
								</div>
								<div class="col-12 d-flex justify-content-end  mb-5">
									<button class="btn btn-lg btn-outline-primary">Send</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
);
